export interface CalendarPeriod {
  month: number
  year: number
}

export interface ClassificationPeriodState {
  period: CalendarPeriod
  classification_pending?: boolean
  previous_month_classification_pending?: boolean
  previous_period?: CalendarPeriod
}

export const previousCalendarPeriod = (
  period: CalendarPeriod
): CalendarPeriod =>
  period.month === 1
    ? { month: 12, year: period.year - 1 }
    : { month: period.month - 1, year: period.year }

export const classificationBlockingPeriod = (
  row: ClassificationPeriodState
): CalendarPeriod | null => {
  if (row.classification_pending) return row.period
  if (row.previous_month_classification_pending) {
    return row.previous_period ?? previousCalendarPeriod(row.period)
  }
  return null
}
